/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { WrapperMetrics } from './styles';
import Loader from '../../loader';
import NodesModal from '../../dashboard/table/nodesModal';

import utils from '../utils';
import { getNodesPerCategory } from '../../../store/fuse/monitoreo';

const { COLOR_MAP } = utils;

const Index = (props) => {
  const { metrics } = props;
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [modalType, setModalType] = useState('node');
  const handleClose = () => setOpen(false);

  const loadingNodes = useSelector((state) => state.fuse?.monitoreo?.loadingNodes);
  const nodesData = useSelector((state) => state?.fuse?.monitoreo?.nodes);
  const filtersSelected = useSelector((state) => state?.fuse?.monitoreo?.filtersSelected);
  const metricsData = useSelector((state) => state?.fuse?.dashboard?.dashboard?.metrics);

  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);

  const handleDeviceClick = (data, color) => {
    let metricName = data.nameLabel;
    setModalType('nodo');
    if (data.nameLabel === 'Ancho de Banda Entrada') {
      metricName = 'Ancho Banda';
      setModalType('interface');
    }
    if (data.nameLabel === 'Ancho de Banda Salida') {
      metricName = 'Ancho Banda Subida';
      setModalType('interface');
    }
    let metricType = 'metric';
    if (data.nameLabel === 'Ancho de Banda Entrada') {
      metricType = 'anchobandaentrada';
    }
    if (data.nameLabel === 'Ancho de Banda Salida') {
      metricType = 'anchobandasalida';
    }
    const metricSelected = metricsData.find((metric) => metric.metrica === metricName);
    dispatch(getNodesPerCategory(metricType, metricSelected.id, color, filtersSelected));
    setOpen(true);
  };

  return (
    <WrapperMetrics>
      <div
        className="w-full flex flex-col m-10 rounded-lg mt-0 lg:ml-20 lg:pl-20"
        style={{ backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white' }}
      >
        <div className="text-metric">
          <h2>Metricas</h2>
          <h4>Total de Dispositivos</h4>
        </div>
        <div className="flex flex-col section-grid">
          {metrics.map((data, index) => (
            <div className="section-point" key={index}>
              <div className="section-metric">
                <strong>{data.nameLabel}</strong>
              </div>
              <div className="section-percentage">
                {data.verde !== '0' && (
                  <div>
                    <div>
                      <div
                        className={`rounded-div ${data.verde !== '0' ? '' : 'unclickable-indicator'}`}
                        style={{ background: COLOR_MAP.verde, cursor: 'pointer' }}
                        onClick={() => {
                          handleDeviceClick(data, 'verde');
                        }}
                        onKeyDown={() => {
                          handleDeviceClick(data, 'verde');
                        }}
                      />
                    </div>
                    {data.verde}
                  </div>
                )}
                {data.amarillo !== '0' && (
                  <div>
                    <div>
                      <div
                        className={`rounded-div ${data.amarillo !== '0' ? '' : 'unclickable-indicator'}`}
                        style={{ background: COLOR_MAP.amarillo, cursor: 'pointer' }}
                        onClick={() => {
                          handleDeviceClick(data, 'amarillo');
                        }}
                        onKeyDown={() => {
                          handleDeviceClick(data, 'amarillo');
                        }}
                      />
                    </div>
                    {data.amarillo}
                  </div>
                )}
                {data.rojo !== '0' && (
                  <div>
                    <div>
                      <div
                        className={`rounded-div ${data.rojo !== '0' ? '' : 'unclickable-indicator'}`}
                        style={{ background: COLOR_MAP.rojo, cursor: 'pointer' }}
                        onClick={() => {
                          handleDeviceClick(data, 'rojo');
                        }}
                        onKeyDown={() => {
                          handleDeviceClick(data, 'rojo');
                        }}
                      />
                    </div>
                    {data.rojo}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        {props.loading && <Loader nameComponent="metrics" nameLabel="Metricas" />}
      </div>
      <NodesModal
        openModal={open}
        handleCloseModal={handleClose}
        loading={loadingNodes}
        nodesData={nodesData}
        redirectPath="/monitoreo"
        type={modalType}
      />
    </WrapperMetrics>
  );
};

export default Index;
